var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{ref:"snackbar",model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.snackbar_message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }